import {
  Directive,
  HostBinding,
  HostListener,
  computed,
  input,
} from '@angular/core';
import { LoadingDirective } from './loading.directive';

@Directive({
  selector: 'a[nttLinkButton], button[nttLinkButton]',
})
export class NttLinkButton extends LoadingDirective {
  protected override _shouldAddDots = false;
  theme = input<
    'link-outline-primary' | 'link-outline-secondary' | 'link-outline-error'
  >('link-outline-primary');
  size = input<'tiny' | 'small'>('small');
  disabled = input(false);

  hostClasses = computed(() =>
    [
      'ntt-button',
      `ntt-button--${this.theme()}`,
      `ntt-button--${this.size()}`,
      this.disabled() ? 'ntt-button--disabled' : '',
      this.loading() ? 'ntt-button-loading' : '',
      this.loading() ? `ntt-button-loading--${this.loadingPosition()}` : '',
    ]
      .filter(Boolean)
      .join(' '),
  );

  @HostBinding('attr.aria-disabled') get ariaDisabled() {
    return this.disabled() ? 'true' : undefined;
  }

  @HostBinding('attr.role') readonly role = 'button';

  @HostBinding('attr.tabindex') get tabindex() {
    return this.disabled() || this.loading() ? '-1' : undefined;
  }

  @HostBinding('class') get hostClassesValue() {
    return this.hostClasses();
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    this._elementRef.nativeElement.focus();
    if (this.loading() || this.disabled()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
